<template>
  <div class="wealth-withdraw">
    <NavBar hide-border>
      <template #left>
        <BackButton />
      </template>
    </NavBar>
    <main class="wealth-withdraw__content">
      <Heading class="wealth-withdraw__title">
        Escolha a carteira para resgatar
      </Heading>
      <LoaderIndicator v-if="isLoading" with-container size="32" />
      <HelperViewStatus
        v-else-if="hasError"
        class="wealth-withdraw__error"
        generic-error
        button-label="Tentar novamente"
        @click="fetchPortfolios"
      />
      <Grid v-else :columns="[1, 1]" gutter="xm">
        <PortfolioCardV2
          v-for="(portfolio, index) in portfolioList"
          :key="index"
          class="wealth-withdraw__portfolio-item"
          :portfolio="portfolio"
          @click="gotToWithdraw(portfolio)"
        />
      </Grid>
    </main>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  Heading,
  Grid,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { PortfolioCardV2 } from '@/modules/wealth/components/PortfolioCardV2';

import { getPortfoliosToWithdraw } from '@/modules/wealth/services/withdraw-v2';
import { IPortfolioList, PortfolioCategories } from '@/types/models/Portfolio';

const router = useRouter();

const portfolioList = ref<IPortfolioList[]>([]);
const isLoading = ref(false);
const hasError = ref(false);

function gotToWithdraw(portfolio: IPortfolioList) {
  const routerName: Record<PortfolioCategories, string> = {
    [PortfolioCategories.Custom]: 'wealthProductWithdrawal',
    [PortfolioCategories.VariableIncome]: 'variableIncomeWithdraw',
    [PortfolioCategories.WarrenManagement]: 'withdrawByPortfolio'
  };

  router.push({
    name: routerName[portfolio.type],
    params: { id: portfolio.id }
  });
}

async function fetchPortfolios() {
  isLoading.value = true;
  hasError.value = false;

  try {
    portfolioList.value = await getPortfoliosToWithdraw();
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchPortfolios();
});
</script>

<style lang="less" scoped>
.wealth-withdraw {
  &__content {
    max-width: 832px;
    margin: 0 auto;
    padding: @size-spacing-x800 @size-spacing-x400;
  }

  &__title {
    text-align: center;
    margin-bottom: @size-spacing-x1100;
  }

  &__portfolio-item {
    margin-bottom: @size-spacing-x500;
  }

  &__error {
    margin: 0 auto;
  }
}
</style>
